import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useMediaQuery, useTheme as useMuiTheme } from '@mui/material';
// Cutover 2026-05-15 (Session 2): legacy Sidebar replaced by AccessSidebar
// (built on the new useAccess + adminMenus stack). The legacy `./Sidebar`
// file is still in the repo and will be deleted in Session 3.
import AccessSidebar from '../access/AccessSidebar';
import Topbar from './Topbar';
import './Layout.css';

const Layout: React.FC = () => {
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('lg'));
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Close mobile sidebar on route change
  useEffect(() => {
    if (isMobile) {
      setSidebarOpen(false);
    }
  }, [location.pathname, isMobile]);

  return (
    <div className="admin-layout">
      {/* Sidebar - Desktop (fixed) */}
      {!isMobile && (
        <div className="admin-sidebar-desktop">
          <AccessSidebar />
        </div>
      )}

      {/* Sidebar - Mobile (overlay) */}
      {isMobile && sidebarOpen && (
        <div className="admin-sidebar-mobile-overlay">
          <div
            className="admin-sidebar-backdrop"
            onClick={() => setSidebarOpen(false)}
          />
          <div className="admin-sidebar-mobile-panel">
            <AccessSidebar onItemClick={() => setSidebarOpen(false)} />
          </div>
        </div>
      )}

      {/* Main content area */}
      <div className={`admin-main ${!isMobile ? 'with-sidebar' : ''}`}>
        <Topbar
          onToggleSidebar={() => setSidebarOpen(true)}
          sidebarOpen={sidebarOpen}
        />

        <main className="admin-content">
          <div className="admin-content-inner">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
